import { PhoneCall, Wrench, CheckCircle } from 'lucide-react';

const steps = [
  {
    number: '1',
    title: 'You Call Us',
    description: 'Reach us at 647-919-6893 anytime.',
    icon: PhoneCall,
  },
  {
    number: '2',
    title: 'Expert Tech Arrives',
    description: '2-hour arrival window. Licensed & insured pros.',
    icon: Wrench,
  },
  {
    number: '3',
    title: 'Appliance Fixed Fast',
    description: 'Same-day repair with warranty on all work.',
    icon: CheckCircle,
  },
];

export const ThreeStepFix = () => {
  return (
    <section className="py-20 bg-[#F8F9FC]" data-testid="three-step-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span 
            className="inline-block px-4 py-2 rounded-full text-sm font-semibold mb-4"
            style={{ background: '#1A2B4C', color: 'white' }}
          >
            Simple Process
          </span>
          <h2 
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ fontFamily: 'Montserrat, sans-serif', color: '#1A2B4C' }}
          >
            The 3-Step Fix
          </h2>
          <p className="text-lg text-[#475569] max-w-2xl mx-auto">
            We've made getting your appliances fixed as simple as possible.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div 
                key={step.number}
                className={`relative text-center fade-up-delay-${index}`}
                data-testid={`step-${step.number}`}
              >
                {/* Connector Line (hidden on last item and mobile) */}
                {index < 2 && (
                  <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-[#FF6B00] to-transparent" />
                )}
                
                {/* Step Circle */}
                <div className="relative inline-flex items-center justify-center mb-6">
                  <div 
                    className="step-circle w-24 h-24 rounded-full flex items-center justify-center shadow-lg"
                    style={{ background: '#1A2B4C' }}
                  >
                    <IconComponent size={36} className="text-white" />
                  </div>
                  <div 
                    className="absolute -top-2 -right-2 w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-sm"
                    style={{ background: '#FF6B00', fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {step.number}
                  </div>
                </div>

                {/* Content */}
                <h3 
                  className="text-xl font-bold mb-3"
                  style={{ fontFamily: 'Montserrat, sans-serif', color: '#1A2B4C' }}
                >
                  {step.title}
                </h3>
                <p className="text-[#475569] max-w-xs mx-auto">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <a
            href="tel:647-919-6893"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full font-bold text-lg text-white transition-transform hover:scale-105 shadow-lg"
            style={{ background: '#FF6B00', fontFamily: 'Montserrat, sans-serif' }}
            data-testid="three-step-cta"
          >
            <PhoneCall size={22} />
            <span>Start Your Repair - Call Now</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ThreeStepFix;
